<template>
  <div
    v-if="title"
    class="tw-flex tw-flex-1 tw-items-center tw-min-h-[26px] tw-py-1"
  >
    <span class="tw-text-[12px] tw-font-normal tw-text-[#211F58] tw-px-2">
      {{ title }}
    </span>
  </div>
  <template v-if="isShowDetail && !!detail">
    <div
      v-if="Array.isArray(detail)"
      class="tw-flex !tw-flex-col tw-flex-1"
      :style="`background-color: ${level >= 1 ? '#FCFCFC' : '#fff'}`"
    >
      <div
        v-for="(item, index) in detail"
        :key="index"
        class="tw-flex tw-flex-1 tw-min-h-[26px] tw-py-1 tw-border-0 tw-border-t tw-border-solid tw-border-[#EFF0F1]"
      >
        <span
          class="tw-text-[12px] tw-font-normal tw-text-[#878787]"
          :style="`margin-left: ${
            !level ? 8 : 35 * level
          }px; margin-right: 8px; color: ${level >= 1 ? '#878787' : '#211F58'}`"
        >
          {{ renderValue(item) }}
        </span>
      </div>
    </div>

    <template v-else>
      <div
        v-for="[key, value] in Object.entries(detail)"
        :key="key"
        class="tw-flex tw-items-center tw-flex-1 tw-min-h-[26px] tw-border-0 tw-border-t tw-border-solid tw-border-[#EFF0F1]"
      >
        <div
          v-if="typeof value !== 'object' || !value"
          class="tw-flex tw-text-[12px] tw-font-normal tw-break-words tw-flex-1 tw-items-center tw-min-h-[26px] tw-py-1"
          :style="`margin-left: ${
            !level ? 8 : 35 * level
          }px; margin-right: 8px`"
        >
          <span
            class="tw-text-[#878787] tw-min-w-[180px] tw-max-w-[180px] tw-capitalize"
          >
            {{ renderValue(key, ":") }}
          </span>
          <span
            class="tw-text-[#211F58] tw-min-w-[180px] tw-max-w-[180px]"
            :style="`color: ${level >= 1 ? '#878787' : '#211F58'}`"
          >
            {{ renderValue(value) }}
          </span>
        </div>

        <div v-else class="tw-flex tw-flex-col tw-flex-1">
          <div
            class="tw-flex tw-flex-1 tw-items-center tw-min-h-[26px] tw-py-1"
          >
            <span
              class="tw-text-[12px] tw-font-normal tw-text-[#878787] tw-min-w-[180px] tw-max-w-[180px] tw-capitalize"
              :style="`margin-left: ${
                !level ? 8 : 35 * level
              }px; margin-right: 8px`"
            >
              {{ renderValue(key, ":") }}
            </span>
          </div>
          <template v-if="Array.isArray(value)">
            <CellDetailType2
              v-for="(item, index) in value"
              :key="index"
              :detail="item"
              :level="level + 1"
              :is-show-detail="isShowDetail"
            />
          </template>
          <template v-else>
            <CellDetailType2
              :detail="value"
              :level="level + 1"
              :is-show-detail="isShowDetail"
            />
          </template>
        </div>
      </div>
    </template>
  </template>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    title?: string;
    detail?: object | null;
    isShowDetail?: boolean;
    level?: number;
  }>(),
  {
    title: "",
    detail: null,
    isShowDetail: false,
    level: 0,
  },
);

const renderValue = (value: any, suffix?: string) => {
  return `${value === null ? "N/A" : `${value}`}${suffix || ""}`;
};
</script>
